import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Permission } from '@/models/Permission';

/** Clinical-permission code names and the getters that gate diagnoses, non-profile meds, and allergies. */
export const ClinicalPermissionCodeNames = {
    manageDiagnoses: 'Patient Dashboard/Manage Diagnoses',
    manageNonProfileMedications: 'Patient Dashboard/Manage Non-Profile Medications',
    updateAllergies: 'Processing/Patient Allergy and Meds Updates',
} as const;

@Component
export default class ClinicalPermissionsMixin extends Vue {
    get canManageDiagnoses(): boolean {
        return this.$permissions.some(
            (p: Permission) => p.permissionCodeName === ClinicalPermissionCodeNames.manageDiagnoses
        );
    }

    get canManageNonProfileMeds(): boolean {
        return this.$permissions.some(
            (p: Permission) => p.permissionCodeName === ClinicalPermissionCodeNames.manageNonProfileMedications
        );
    }

    get canUpdateAllergies(): boolean {
        return this.$permissions.some(
            (p: Permission) => p.permissionCodeName === ClinicalPermissionCodeNames.updateAllergies
        );
    }
}
